import apple from "../../assets/apple-logo.png";
import google from "../../assets/google-play.png";
import facebook from "../../assets/facebook.png";
import insta from "../../assets/insta.png";
import linkedin from "../../assets/linkedin.png";
import twitter from "../../assets/twitter.png";
import whatsapp from "../../assets/whatsapp.png";

const Footer = () => {
  return (
    <div className="bg-footerBg text-white">
      <div className="max-lg:px-6 text-center py-20">
        <h1 className="font-semibold text-[30px] lg:text-[42px] max-lg:mb-3">
          Get started with our app
        </h1>
        <span className="text-border text-lg lg:max-w-[400px] mx-auto">
          Get access to easy and convenient transportation solutions by
          downloading the ZAP app today!
        </span>
        <div className="lg:max-w-[350px] flex items-center justify-center space-x-5 mt-7 lg:mx-auto">
          <div className="download-btn bg-white text-left">
            <div>
              <img className="w-[24px]" alt="" src={apple} />
            </div>
            <div>
              <span className="text-xs text-paragraph">Download on the</span>
              <h1 className="font-medium text-primaryBlack -mt-1">App Store</h1>
            </div>
          </div>
          <div className="download-btn bg-white text-left">
            <div>
              <img className="w-[24px]" alt="" src={google} />
            </div>
            <div>
              <span className="text-xs text-paragraph">Get it on</span>
              <h1 className="font-medium text-primaryBlack -mt-1">
                Google Play
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:flex justify-between px-6 lg:px-16 py-10 max-lg:space-y-9">
        <div>
          <h1 className=" font-semibold text-lg">
            &copy; 2023 Zap Technologies
          </h1>
        </div>
        <div className="lg:grid grid-cols-3 gap-14 max-lg:space-y-8">
          <div>
            <h2 className=" text-xl font-semibold">Products</h2>
            <div className="space-y-2 mt-4">
              <span className="">Driver app</span>
              <span className="">User app</span>
            </div>
          </div>
          <div>
            <h2 className=" text-xl font-semibold">Legal</h2>
            <div className="space-y-2 mt-4">
              <span className="">Terms of use</span>
              <span className="">Privacy</span>
            </div>
          </div>
          <div>
            <h2 className=" text-xl font-semibold">Company</h2>
            <div className="space-y-2 mt-4">
              <span className="">Careers</span>
              <span className="">About us</span>
              <span className="">FAQ</span>
            </div>
          </div>
        </div>
        <div className="flex space-x-3">
          <img alt="social" src={facebook} className="w-8 h-8" />
          <img alt="social" src={linkedin} className="w-8 h-8" />
          <img alt="social" src={twitter} className="w-8 h-8" />
          <img alt="social" src={insta} className="w-8 h-8" />
          <img alt="social" src={whatsapp} className="w-8 h-8" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
